var map = {
	"./assets/emoji": "914f",
	"./assets/emoji.json": "914f",
	"./assets/fonts.scss": "7929",
	"./assets/images/category.svg": "54d0",
	"./assets/images/date.svg": "9bcd",
	"./assets/images/img.svg": "4b72",
	"./assets/images/logo.svg": "e347",
	"./assets/images/sharp.svg": "a85d",
	"./assets/images/string.svg": "6d81",
	"./assets/normalize.scss": "a636",
	"./assets/style.scss": "73ec",
	"./assets/variables.scss": "7133"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "53a4";